export default __webpack_public_path__ + "static/media/uploader-abbottLite-problem-1.130b5ec0.png";